import { Typography } from "@analyticsMD/quil";
import PatientConsideration from "../types/PatientConsideration";
import ReactMarkdown from "react-markdown";

export class PatientConsiderationObj {
  patientConsideration: PatientConsideration;
  constructor(patientConsideration: PatientConsideration) {
    this.patientConsideration = patientConsideration;
  }

  getDescription(): JSX.Element | null {
    return (
      <>
        <Typography variant="h6" align="left" fontWeight="bold" fontSize={13}>
          {this.patientConsideration.consideration_reasoning_title}
        </Typography>
        <Typography variant="body1" align="left" fontSize={11}>
          <ReactMarkdown>
            {this.patientConsideration.consideration_reasoning_description}
          </ReactMarkdown>
        </Typography>
      </>
    );
  }
}
